/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_MersisInputs */

const tr_onbilgi_s1_label_mersis = /** @type {(inputs: Onbilgi_S1_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS No:`)
};

const en_onbilgi_s1_label_mersis = /** @type {(inputs: Onbilgi_S1_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS No:`)
};

const de_onbilgi_s1_label_mersis = /** @type {(inputs: Onbilgi_S1_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS-Nr.:`)
};

const ru_onbilgi_s1_label_mersis = /** @type {(inputs: Onbilgi_S1_Label_MersisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MERSİS №:`)
};

/**
* | output |
* | --- |
* | "MERSİS No:" |
*
* @param {Onbilgi_S1_Label_MersisInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_mersis = /** @type {((inputs?: Onbilgi_S1_Label_MersisInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_MersisInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_mersis(inputs)
	if (locale === "de") return de_onbilgi_s1_label_mersis(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_mersis(inputs)
	return tr_onbilgi_s1_label_mersis(inputs)
});